import { TouchpointType } from 'lib/models/touchpoint';

export enum SearchPageType {
  JOBS = 'jobs',
  INTERNSHIPS = 'internships',
  EVENTS = 'events',
  COMMUNITIES = 'communities',
  COMPANIES = 'companies',
  JOBS_AND_INTERNSHIPS = 'jobs-and-intersnships',
}

export enum SearchPageCategory {
  OPPORTUNITY = 'opportunity',
  ORGANIZATION = 'organization',
}

export enum SearchPageSortBy {
  MOST_RELEVANT = 'most_relevant',
  LATEST = 'latest',
  CLOSING_SOONEST = 'closing_soonest',
}

export enum SearchPageSortOrder {
  ASC = 'asc',
  DESC = 'desc',
}

export function getSearchPageTypeFromTouchpointType(
  type: TouchpointType
): SearchPageType | null {
  switch (type) {
    case TouchpointType.Job:
      return SearchPageType.JOBS;
    case TouchpointType.Internship:
      return SearchPageType.INTERNSHIPS;
    case TouchpointType.Event:
      return SearchPageType.EVENTS;
    default:
      return null;
  }
}
